<template>
  <van-dialog
    v-model="dialogVisible"
    :show-confirm-button="false"
    width="375px"
    :close-on-click-overlay="true"
    class="member-benefit-dialog"
  >
    <div class="member-benefit-container">
      <div
        class="member-benefit-title"
        :style="{
          background: `url(${titleImg})`,
          'background-size': '100% 100%',
        }"
      ></div>
      <img
        @click="dialogVisible = false"
        class="close"
        src="@/assets/images/wrate-close.png"
        alt=""
      />
      <div class="member-benefit-box">
        <div class="member-item" v-for="(item, i) in equityStatementList" :key="i">
          <span>{{item.title}}</span>
          <img :src="dotPath" alt="" />
          <span>{{item.desc}}</span>
        </div>
        <span class="tips">…更多特权敬请期待…</span>
      </div>
    </div>
  </van-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    levelFlag: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {};
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
    titleImg() {
      if (this.levelFlag == 1) {
        return require("@/assets/images/bg_vip_desc_dialog_bg_1.png");
      } else if (this.levelFlag == 2) {
        return require("@/assets/images/bg_vip_desc_dialog_bg_2.png");
      } else if (this.levelFlag == 3) {
        return require("@/assets/images/bg_vip_desc_dialog_bg_3.png");
      }
    },
    dotPath() {
        if (this.levelFlag == 1) {
        return require("@/assets/images/path.png");
      } else if (this.levelFlag == 2) {
        return require("@/assets/images/path2.png");
      } else if (this.levelFlag == 3) {
        return require("@/assets/images/path3.png");
      }
    },
    equityStatementList() {
        if (this.levelFlag == 1) {
            return [
                {
                    title: '专属折扣',
                    desc: '部分10折游戏，可联系客服开通折扣特权'
                },
                {
                    title: '专属客服',
                    desc: '部分游戏大额充值可联系客服，协商充值返利'
                },
                {
                    title: '免费退款',
                    desc: '每周1次，续冲代金券退款，免收手续费'
                },
                {
                    title: '意外保险',
                    desc: '下班时间，因平台原因导致充值不到账，按照实付金额10%给予优惠券补偿（该时间段内首次充值的账号不在补充范围内）'
                }
            ]
        } else if (this.levelFlag == 2) {
            return [
                {
                    title: '专属折扣',
                    desc: '部分10折游戏，可联系客服开通折扣特权'
                },
                {
                    title: '专属客服',
                    desc: '部分游戏大额充值可联系客服，协商充值返利'
                },
                {
                    title: '0元试玩',
                    desc: '每月可申请1款游戏进行6元首充'
                },
                {
                    title: '免费退款',
                    desc: '每周一次，续充代金券退款，免收手续费（每个游戏账号限退一次）'
                },
                {
                    title: '手续费抵扣',
                    desc: '退款订单若需扣除手续费，当前会员每月最多抵扣20元'
                }
            ]
        } else if (this.levelFlag == 3) {
            return [
                {
                    title: '0元试玩',
                    desc: '每月可申请1款游戏进行6元首充'
                },
                {
                    title: '免费退款',
                    desc: '每周一次，续充代金券退款，免收手续费（每个游戏账号限退一次）'
                },
                {
                    title: '手续费抵扣',
                    desc: '退款订单若需扣除手续费，当前会员每月最多抵扣20元'
                },
                {
                    title: '意外保险',
                    desc: '下班时间，因平台原因导致充值不到账，按照实付金额10%给予优惠券补偿（该时间段内首次充值的账号不在补充范围内）'
                }
            ]
        }
    }

  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.member-benefit-dialog,
.van-dialog__content {
  overflow: visible; /* 允许内容超出 */
}
.member-benefit-container {
  position: relative;

  .member-benefit-title {
    width: 600px;
    height: 200px;

    background-size: 100% 100%;
    margin: 0 auto;
  }

  .member-benefit-box {
    background: #ffffff;
    width: 600px;
    margin: 0 auto;
    padding: 40px 50px;

    .member-item {
      text-align: center;
      margin-bottom: 40px;
      span {
        display: block;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 24px;
        color: #646464;
        line-height: 33px;

        &:last-child {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #999999;
        }
      }
      img {
        width: 160px;
        height: 16px;
        margin-bottom: 14px;
        margin-top: 6px;
      }
    }
    .tips {
      display: block;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #fa6400;
      text-align: center;
    }
  }
  .close {
    width: 36px;
    height: 36px;
    position: absolute;
    right: 113px;
    top: 30px;
  }
}
.van-dialog {
  background: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/memberBenefitDialog.vue